import Vue from 'vue'
import Tawk from 'vue-tawk'
  
Vue.use(Tawk, {
    tawkSrc: process.env.TAWK_SRC || 'https://embed.tawk.to/60bf954a4ae6dd0abe7d289d/1f7m5ubkh'
})
